import { render, staticRenderFns } from "./Who.vue?vue&type=template&id=bfa58f12&scoped=true&"
var script = {}
import style0 from "./Who.vue?vue&type=style&index=0&id=bfa58f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa58f12",
  null
  
)

export default component.exports